// (function () {
//   const BREEZE_SRC = "https://sdk.breeze.in/electron/144.0.0/index.js";
//   let breezeLoaded = false;
//   let breezeScriptEl = null;

//   // --- DEBUG ---
//   const D = (window.__breezeDebug = window.__breezeDebug || {
//     loads: 0, patches: 0, strips: 0, opens: 0, closes: 0
//   });
//   const dbg = (...a) => console.log("[breeze-debug]", ...a);

//   function loadScriptOnce(src, attrs = {}) {
//     return new Promise((resolve, reject) => {
//       if (breezeLoaded) { dbg("already loaded"); return resolve(); }
//       const s = document.createElement('script');
//       s.type = 'module';
//       s.src = src;
//       s.async = true;
//       Object.entries(attrs).forEach(([k,v]) => s.setAttribute(k, v));
//       s.onload = () => { breezeLoaded = true; breezeScriptEl = s; D.loads++; dbg("sdk loaded", { loads: D.loads }); resolve(); };
//       s.onerror = (e) => { console.warn("[breeze-debug] sdk load error", e); reject(e); };
//       document.head.appendChild(s);
//       dbg("sdk <script> injected");
//     });
//   }

//   function patchBreezeIframePermissions(root = document) {
//     root.querySelectorAll('iframe').forEach((el) => {
//       try {
//         if (/app\.breeze\.in\/login/i.test(el.src)) {
//           const cur = el.getAttribute('allow') || '';
//           if (!/otp-credentials/.test(cur)) {
//             el.setAttribute('allow', (cur ? cur + '; ' : '') + "otp-credentials 'none'");
//             D.patches++; dbg("patched iframe allow", { src: el.src, patches: D.patches });
//           }
//         }
//       } catch {}
//     });
//   }

//   function stripBreezeIframes() {
//     const frames = Array.from(document.querySelectorAll('iframe[src*="app.breeze.in/login"]'));
//     frames.forEach(el => { try { el.remove(); } catch {} });
//     if (frames.length) { D.strips += frames.length; dbg("removed breeze iframes", { removed: frames.length, totalStrips: D.strips }); }
//   }

//   function onDrawerOpen() {
//     D.opens++; dbg("drawer OPEN", { opens: D.opens });
//     loadScriptOnce(BREEZE_SRC, {
//       id: 'breeze-script-tag',
//       'data-environment': 'release',
//       'data-platform': 'shopify',
//       'data-enable-external-trackers': 'true',
//       'data-enable-snap-tracker': 'true',
//       'data-enable-ga': 'true',
//       'data-enable-fbp': 'true',
//       'data-emit-tracker-events': 'true',
//       'data-ga4-measurement-id': '',
//       'data-ga-version': 'new',
//       'data-merchantid': 'ceneindia',
//       'ghost-mode': 'false'
//     }).then(() => {
//       patchBreezeIframePermissions();
//     }).catch(()=>{});
//   }
//   function onDrawerClose() {
//     D.closes++; dbg("drawer CLOSE", { closes: D.closes });
//     stripBreezeIframes();
//   }

//   function wireDrawerHooks() {
//     const drawer = document.querySelector('cart-drawer, .cart-drawer, [data-cart-drawer]');
//     if (!drawer) { dbg("drawer not found at startup"); return; }

//     const mo = new MutationObserver(() => {
//       const isOpen =
//         drawer.hasAttribute('open') ||
//         drawer.getAttribute('aria-hidden') === 'false' ||
//         drawer.classList.contains('is-open') ||
//         drawer.classList.contains('active');
//       isOpen ? onDrawerOpen() : onDrawerClose();
//     });
//     mo.observe(drawer, { attributes: true, attributeFilter: ['open','aria-hidden','class'] });

//     document.addEventListener('cart:drawer:open', onDrawerOpen);
//     document.addEventListener('cart:drawer:close', onDrawerClose);

//     dbg("wired drawer hooks");
//   }

//   addEventListener('pagehide', () => {
//     dbg("pagehide -> strip iframes");
//     stripBreezeIframes();
//   });

//   document.addEventListener('click', (e) => {
//     const a = e.target.closest('a[href]');
//     if (!a) return;
//     const href = a.getAttribute('href') || '';
//     if (/\/products\//.test(href)) {
//       dbg("product link click -> strip iframes before nav");
//       stripBreezeIframes();
//       requestAnimationFrame(()=>{});
//     }
//   }, true);

//   document.addEventListener('DOMContentLoaded', () => {
//     dbg("DOMContentLoaded");
//     wireDrawerHooks();
//   });
// })();

(function () {
    const BREEZE_SRC = "https://sdk.breeze.in/electron/144.0.0/index.js";
    let breezeLoaded = false;
    let breezeScriptEl = null;

    function loadScriptOnce(src, attrs = {}) {
        return new Promise((resolve, reject) => {
          if (breezeLoaded) return resolve();
          const s = document.createElement('script');
          s.type = 'module';
          s.src = src;
          s.async = true;
          Object.entries(attrs).forEach(([k,v]) => s.setAttribute(k, v));
          s.onload = () => { breezeLoaded = true; breezeScriptEl = s; resolve(); };
          s.onerror = reject;
          document.head.appendChild(s);
        });
    }

      // Breeze sometimes injects a login iframe that enables WebOTP.
      // Patch/removal helpers to keep the page bfcache-eligible.
    function patchBreezeIframePermissions(root = document) {
        root.querySelectorAll('iframe').forEach((el) => {
          try {
            if (/app\.breeze\.in\/login/i.test(el.src)) {
              const cur = el.getAttribute('allow') || '';
              if (!/otp-credentials/.test(cur)) {
                el.setAttribute('allow', (cur ? cur + '; ' : '') + "otp-credentials 'none'");
                console.log('[bfcache] Patched Breeze iframe permissions on collection page.');
              }
            }
          } catch {}
        });
    }
    function stripBreezeIframes() {
        document.querySelectorAll('iframe[src*="app.breeze.in/login"]').forEach(el => {
          try { el.remove(); } catch {}
        });
    }

    // Detect your cart drawer open/close.
    // Works with many Shopify themes that toggle <cart-drawer open>, [aria-hidden], or emit custom events.
    function onDrawerOpen() {
        // Load Breeze now (only when the user opens the drawer)
        loadScriptOnce(BREEZE_SRC, {
          id: 'breeze-script-tag',
          'data-environment': 'release',
          'data-platform': 'shopify',
          'data-enable-external-trackers': 'true',
          'data-enable-snap-tracker': 'true',
          'data-enable-ga': 'true',
          'data-enable-fbp': 'true',
          'data-emit-tracker-events': 'true',
          'data-ga4-measurement-id': '',
          'data-ga-version': 'new',
          'data-merchantid': 'ceneindia',
          'ghost-mode': 'false'
        }).then(() => {
          // Immediately neuter WebOTP so collection stays bfcache-friendly
          patchBreezeIframePermissions();
        }).catch(()=>{});
    }
    function onDrawerClose() {
    // Remove the OTP iframe so the page can be kept in bfcache
    stripBreezeIframes();
    }

    // Hook into common drawer signals.
    function wireDrawerHooks() {
        const drawer = document.querySelector('cart-drawer, .cart-drawer, [data-cart-drawer]');
        if (!drawer) return;

        // 1) Attribute watchers (open / aria-hidden)
        const mo = new MutationObserver((muts) => {
          for (const m of muts) {
            if (m.type === 'attributes') {
              const isOpen =
                drawer.hasAttribute('open') ||
                drawer.getAttribute('aria-hidden') === 'false' ||
                drawer.classList.contains('active') ||
                drawer.classList.contains('open');
              isOpen ? onDrawerOpen() : onDrawerClose();
            }
          }
        });
        mo.observe(drawer, { attributes: true, attributeFilter: ['open','aria-hidden','class'] });

        // 2) Listen for theme events if present
        document.addEventListener('cart:drawer:open', onDrawerOpen);
        document.addEventListener('cart:drawer:close', onDrawerClose);
    }

    // Remove Breeze artifacts before leaving the page (don’t use beforeunload!)
    addEventListener('pagehide', () => {
        stripBreezeIframes();
    });

    // If a user clicks a product link, strip the iframe just before navigation.
    document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href]');
        if (!a) return;
        const href = a.getAttribute('href') || '';
        if (/\/products\//.test(href)) {
          stripBreezeIframes();
          // allow navigation to proceed normally
          requestAnimationFrame(()=>{});
        }
    }, true);
    // Initial wiring
    document.addEventListener('DOMContentLoaded', () => {
        wireDrawerHooks();
    });
})();